export default "__VITE_ASSET__CiBzNVSq__"